function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 6");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols/Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon/Fare/9.-Gass-under-trykk",
  transform: "translate(4.000000, 4.000000)"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(-4.000000, -4.000000)"
}, React.createElement("path", {
  d: "M8.31436066,17.2245508 C8.54780328,18.0948459 9.1655082,18.6852721 9.69403279,18.5433705 L20.0232131,15.7709115 C20.3479344,15.6838295 20.5627541,15.340223 20.6267541,14.8864525 L20.6270164,14.8872393 C20.6611148,14.6558951 20.828459,14.4555016 21.0681967,14.3912393 L23.2557377,13.8029115 C23.4994098,13.7376 23.6305574,13.4367475 23.548459,13.1316984 C23.4668852,12.8266492 23.2030164,12.6325508 22.9596066,12.6978623 L20.7720656,13.285141 C20.5302295,13.3501902 20.2834098,13.2586492 20.138623,13.0729443 L20.1388852,13.0737311 C19.8571803,12.716223 19.5007213,12.528682 19.1775738,12.6155016 L8.84813115,15.3916328 C8.31986885,15.5337967 8.08091803,16.3542557 8.31436066,17.2245508",
  id: "Fill-4836",
  fill: "#0A0B09"
}), React.createElement("path", {
  d: "M5.68434189e-14,15.9304918 L15.9260328,31.8573115 L31.8523279,15.9304918 L15.9260328,-5.68434189e-14 L5.68434189e-14,15.9304918 Z M29.3285246,15.9304918 C28.2250492,17.0342295 17.0295082,28.2297705 15.9260328,29.3335082 C14.8222951,28.2297705 3.62701639,17.0342295 2.52354098,15.9304918 C3.62701639,14.8254426 14.8222951,3.62727869 15.9260328,2.52354098 C17.0295082,3.62727869 28.2250492,14.8254426 29.3285246,15.9304918 L29.3285246,15.9304918 Z",
  id: "Fill-4838",
  fill: "#D8232A"
}))));

var SvgGasUnderPressureIcon = function SvgGasUnderPressureIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGasUnderPressureIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gas-under-pressure-icon.3b435474.svg";
export { ForwardRef as ReactComponent };